/* eslint-disable no-useless-escape */

var isMobileFunc = function () {
    var check = false;
    // eslint-disable-next-line no-useless-escape
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

function getChromeVersion () {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    return raw ? parseInt(raw[2], 10) : false;
}
import '@fortawesome//fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import '@/styles/swal.scss'
import '@/styles/styles.scss'
// import "./registerServiceWorker"
import 'mdbvue/lib/mdbvue.css'
import Vue from 'vue'
import App from './App.vue'
import VueToast from 'vue-toast-notification';
import VCalendar from 'v-calendar';

import store from './store'

import router from './router'
import axios from "axios";
import * as mdbvue from 'mdbvue'
import * as cv from './opencv'

import {i18n} from "./translations";
import 'vue-toast-notification/dist/theme-sugar.css';
import VueSweetalert2 from 'vue-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
import '@sweetalert2/theme-material-ui/material-ui.css';
import {config} from "@/config";
import localForageService from "@/localForageService";

window.axios = require('axios');

Vue.config.productionTip = false;

import '@tensorflow/tfjs-backend-cpu';
import '@tensorflow/tfjs-backend-webgl';
import '@tensorflow/tfjs-backend-wasm';

const blazeface = require('@tensorflow-models/blazeface');

import * as tf from '@tensorflow/tfjs-core';
import * as tflite from '@tensorflow/tfjs-tflite';
// tflite.setWasmPath(
//     'https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-tflite@0.0.1-alpha.8/dist/'
// );
tflite.setWasmPath(
    'js/'
);




Vue.use(VueSweetalert2);
Vue.use(VCalendar)

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
console.log(params)
let http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
});
if ('key' in params) {
    http = axios.create({
        baseURL: process.env.VUE_APP_BASE_URL,
        headers: {
            "Authorization": "Api-Token " + params.key
        }
    });
}

Vue.prototype.$config = config

Vue.prototype.$http = http;

for (const component in mdbvue) {
    Vue.component(component, mdbvue[component])
}

Vue.prototype.$localForageService = localForageService
window.io = require('socket.io-client');


Vue.mixin({
    methods: {
        isMobile: isMobileFunc
    }
});
Vue.use(VueToast)
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
Sentry.init({
    Vue,
    dsn: "https://f58052c4e94d420086989ed646f824d8@o1156962.ingest.sentry.io/6238772",
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["localhost:8080", "staging.truid.ai","release.truid.ai", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});
console.log(cv)

if (isMobileFunc() && getChromeVersion()!==false && getChromeVersion()>=90) {

    cv.then((r) => {
        console.log("runtime initialized")
        Vue.prototype.$cv = r
        console.log(r)

    }).catch(err => {
        console.log(err)
    })
    tf.ready().then(()=>{
        blazeface.load().then(net => {

            Vue.prototype.$blazeface = net;
            tflite.loadTFLiteModel('object_detector.tflite').then(tfliteModel=>{
                // tflite.loadTFLiteModel('https://tfhub.dev/google/lite-model/object_detection/mobile_object_localizer_v1/1/default/1').then(tfliteModel=>{
                Vue.prototype.$objectDetector = tfliteModel;
                new Vue({
                    router,
                    store,
                    i18n,
                    render: h => h(App)
                }).$mount('#app')
            }).catch(err=>{
                console.log("error in loading detector")
                console.log(err)
            })



        })
    })


//not logged in

}else{
    document.getElementById('app').innerHTML = "<h1 style='text-align: center'>Not Supported On This Browser. Use Chrome 90 or greater on Android</h1>"
}

